export default "__VITE_ASSET__9ae10743__"